module.exports = __webpack_public_path__ + "./img/spreadsheet-info.svg";